import React from 'react';
import { Routes, Route } from 'react-router-dom';
import DocumentationLayout from './documentation/DocumentationLayout';

// Documentation pages
import DocsHome from './documentation/DocsHome';
import GettingStarted from './documentation/GettingStarted';
import PhoneIntegrationDocs from './documentation/integrations/PhoneIntegration';
import WhatsAppIntegrationDocs from './documentation/integrations/WhatsAppIntegration';
import FacebookIntegrationDocs from './documentation/integrations/FacebookIntegration';
import WebsiteIntegrationDocs from './documentation/integrations/WebsiteIntegration';
import LeadManagementDocs from './documentation/LeadManagement';
import PipelineDocs from './documentation/Pipeline';
import FunnelManagementDocs from './documentation/FunnelManagement';
import FormFieldsDocs from './documentation/FormFields';
import RoundRobinDocs from './documentation/RoundRobin';
import DripCampaignsDocs from './documentation/DripCampaigns';
import UserManagementDocs from './documentation/UserManagement';
import RolesPermissionsDocs from './documentation/RolesPermissions';
import ClientInformationDocs from './documentation/ClientInformation';
import AccountSwitchingDocs from './documentation/AccountSwitching';
import UserProfileDocs from './documentation/UserProfile';

const Documentation: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<DocumentationLayout />}>
        <Route index element={<DocsHome />} />
        <Route path="getting-started" element={<GettingStarted />} />

        {/* Integrations */}
        <Route path="integrations/phone" element={<PhoneIntegrationDocs />} />
        <Route path="integrations/whatsapp" element={<WhatsAppIntegrationDocs />} />
        <Route path="integrations/facebook" element={<FacebookIntegrationDocs />} />
        <Route path="integrations/website" element={<WebsiteIntegrationDocs />} />

        {/* Features */}
        <Route path="lead-management" element={<LeadManagementDocs />} />
        <Route path="pipeline" element={<PipelineDocs />} />
        <Route path="funnel-management" element={<FunnelManagementDocs />} />
        <Route path="form-fields" element={<FormFieldsDocs />} />
        <Route path="round-robin" element={<RoundRobinDocs />} />
        <Route path="drip-campaigns" element={<DripCampaignsDocs />} />
        <Route path="user-management" element={<UserManagementDocs />} />
        <Route path="roles-permissions" element={<RolesPermissionsDocs />} />
        <Route path="client-information" element={<ClientInformationDocs />} />
        <Route path="account-switching" element={<AccountSwitchingDocs />} />
        <Route path="user-profile" element={<UserProfileDocs />} />
      </Route>
    </Routes>
  );
};

export default Documentation;
